import { combineReducers } from 'redux'

import { reducer as applyManagedEventsPopup } from './apply_managed_events_popup/slice'
import { reducer as memberships } from './assign/memberships/reducer'
import { reducer as assign } from './assign/slice'

export const reducer = combineReducers({
  assign,
  memberships,
  applyManagedEventsPopup,
})
